import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Button, Row, Col, Popover, Typography, Avatar } from 'antd';
import filter from 'lodash/filter';
import moment from 'moment';
import { SettingFilled, DeleteOutlined } from '@ant-design/icons';
import { BASE } from 'api';
import { ReactComponent as OpeRedLock } from '../../../images/open_lock_red.svg';
import { ReactComponent as OpeBlueLock } from '../../../images/close_lock_blue.svg';
import { ReactComponent as Bluekey } from '../../../images/blue_key.svg';
import { ReactComponent as Changeuser } from '../../../images/change_user.svg';
import { ReactComponent as Seticon } from '../../../images/mec.svg';

const { Paragraph } = Typography;

function Logs({ data, openUserModal }) {
  const { t } = useTranslation();
  return (
    <div
      style={
        data.info.open_close_type === 'pending'
          ? { background: 'rgb(255, 244, 244)' }
          : null
      }
      className="pt-12  pr-0 pb-12 pl-40 border-b-1 border-lightGray"
    >
      <Row align="middle" type="flex">
        <Col style={{ color: '#4F4F4F' }} span={6}>
          {!data.info.previous_transaction && data.info.transaction ? (
            <>
              {moment(data.info.datetime).format('DD.MM.YY')} -{' '}
              {moment(data.info.transaction.paid_till).format('DD.MM.YY')}{' '}
            </>
          ) : (
            moment(data.info.datetime)
              .subtract(
                new Date(data.info.datetime).getTimezoneOffset(),
                'minutes',
              )
              .format('DD MMMM HH:mm')
          )}
        </Col>
        {
          // source target
          data.info.type === 'transaction' &&
          !data.info.previous_transaction ? (
            <>
              {' '}
              <Col span={8}>
                <div
                  className="text-primary cursor-pointer"
                  onClick={() => {
                    openUserModal(data.info.transaction.client);
                  }}
                >
                  {data.info.transaction.client.first_name}
                  {` `} {data.info.transaction.client.last_name}{' '}
                </div>
              </Col>
            </>
          ) : data.user ? (
            data.user.role === 'admin' ? (
              <Col span={8}>
                {data.user.avatar ? (
                  <>
                    <Avatar
                      src={`${BASE}${data.user.avatar}`}
                      className="mr-7 w-16 h-16"
                    />
                    {data.user.first_name} {data.user.last_name}
                  </>
                ) : (
                  <Avatar className="mr-4">{data.user.first_name[0]}</Avatar>
                )}
              </Col>
            ) : (
              <Col span={8}>
                <div
                  className="text-primary cursor-pointer"
                  onClick={() => {
                    openUserModal(data.user);
                  }}
                >
                  {data.user.first_name} {data.user.last_name}
                </div>
              </Col>
            )
          ) : (data.info.type === 'open' &&
              data.info.open_close_type === 'button') ||
            (data.info.type === 'open_failure' &&
              data.info.open_close_type === 'button') ? (
            //открыто по кнопке
            <Col span={8}>{t('button')}</Col>
          ) : data.info.type === 'open' && !data.info.open_close_type ? (
            //открыт механически, неизвестное лицо
            <Col span={8}>{t('undefOpen')}</Col>
          ) : data.info.type === 'close' ? (
            <Col span={8}>{t('close')}</Col>
          ) : null
        }
        <Col className="flex items-center" span={9}>
          {data.info.open_close_type === 'pending' ? (
            <div className="flex items-center">
              <SettingFilled spin className="mr-10" />
              {t('opening')}
            </div>
          ) : data.info.type === 'open' ? (
            <>
              {' '}
              <OpeRedLock className="mr-10" /> <div>{t('boxOpen')}</div>{' '}
            </>
          ) : data.info.type === 'close' ? (
            <>
              {' '}
              <OpeBlueLock className="mr-10" /> <div>{t('boxClose')}</div>{' '}
            </>
          ) : data.info.type === 'open_failure' ? (
            <>{t('open_failure')}</>
          ) : data.info.type === 'close_failure' ? (
            <>{t('close_failure')}</>
          ) : data.info.type === 'transaction' ? (
            //смена арендатора
            <>
              {data.info.previous_transaction &&
              data.info.transaction &&
              data.info.previous_transaction.client_id !==
                data.info.transaction.client_id ? (
                <>
                  <Popover
                    placement="bottom"
                    content={
                      <div className="flex items-center">
                        <Changeuser className="mr-10" />

                        <div className="flex items-center">
                          {t('changeOfTenant')}{' '}
                          {data.info.previous_transaction.client.first_name}{' '}
                          {data.info.previous_transaction.client.last_name}
                          {`—>`}
                          {data.info.transaction.client.first_name}{' '}
                          {data.info.transaction.client.last_name}
                          {''}
                          {data.info.reason !== '' ? (
                            <>{`(${data.info.reason})`}</>
                          ) : null}
                        </div>
                      </div>
                    }
                  >
                    <div className="flex items-center">
                      <Changeuser className="mr-10" />
                      <div className=""></div>
                      <div className="w-3/5 flex items-center">
                        <Paragraph
                          style={{ marginBottom: '0px' }}
                          getPopupContainer={(triggerNode) =>
                            triggerNode.parentNode
                          }
                          ellipsis
                        >
                          {t('changeOfTenant')}{' '}
                          {data.info.previous_transaction.client.first_name}{' '}
                          {data.info.previous_transaction.client.last_name}
                          {`—>`}
                          {data.info.transaction.client.first_name}{' '}
                          {data.info.transaction.client.last_name}
                          {''}
                          {data.info.reason !== '' ? (
                            <>{`(${data.info.reason})`}</>
                          ) : null}
                        </Paragraph>
                      </div>
                    </div>
                  </Popover>
                </>
              ) : // изменён срок аренды
              data.info.previous_transaction &&
                data.info.transaction &&
                data.info.previous_transaction.client_id ===
                  data.info.transaction.client_id ? (
                <Popover
                  content={
                    <div>
                      <div className="flex items-center">
                        <Seticon className="mr-14" />
                        {t('leaseTermChanged')}
                        {` `}
                        {moment(data.info.transaction.paid_till).format(
                          'DD MMMM hh:mm',
                        )}{' '}
                      </div>
                    </div>
                  }
                  placement="bottom"
                >
                  <div>
                    <div className="w-4/5 flex items-center">
                      <Seticon className="mr-14" />
                      <Paragraph style={{ marginBottom: '0px' }} ellipsis>
                        {t('leaseTermChanged')}
                        {` `}
                        {moment(data.info.transaction.paid_till).format(
                          'DD MMMM hh:mm',
                        )}{' '}
                      </Paragraph>
                    </div>
                  </div>
                </Popover>
              ) : // аренда бокса, новая траназкция
              !data.info.previous_transaction && data.info.transaction ? (
                <>
                  <Bluekey className="mr-10" />
                  {t('boxingRent')}
                </>
              ) : null}
            </>
          ) : data.info.type === 'transaction_delete' ? (
            <>
              {data.info.previous_transaction ? (
                <Popover
                  content={
                    <div>
                      <div className="flex items-center">
                        <DeleteOutlined className="mr-14" />
                        {t('transDelete')}. {t('boxisRented')}{' '}
                        {data.info.previous_transaction.client.first_name}{' '}
                        {data.info.previous_transaction.client.last_name}
                      </div>
                    </div>
                  }
                  placement="bottom"
                >
                  <div>
                    <div className="flex items-center w-4/5">
                      <DeleteOutlined className="mr-14" />
                      <Paragraph style={{ marginBottom: '0px' }} ellipsis>
                        {t('transDelete')}. {t('boxisRented')}{' '}
                        {data.info.previous_transaction.client.first_name}{' '}
                        {data.info.previous_transaction.client.last_name}
                      </Paragraph>
                    </div>
                  </div>
                </Popover>
              ) : (
                <> {t('transDelete')}</>
              )}
            </>
          ) : data.info.type === 'transaction_terminate' ? (
            <>{t('leaseCompleted')}</>
          ) : null}
        </Col>
      </Row>
    </div>
  );
}

Logs.propTypes = {};

export default Logs;
